import { axios } from '@/services/axios';

export const updateTemplate = (templateData) => {
    return axios.put('/AATemplate/', templateData);
};
